export const Z_INDEX = {
  // Highcharts background series (internal chart layer)
  chartSeriesBackground: -1,

  // Local stacking — within parent stacking context
  base: 0,
  raised: 1,
  overlay: 2,
  sticky: 3,
  dragging: 5,
  draggingGroup: 9,

  // Base floating UI (Popper default, drawer header, mobile banner)
  floatingAnchor: 10,

  // Chart overlays — legend, tooltip, popup within fullscreen chart
  chartOverlay: 20,
  chartPopup: 21,

  // Blur backdrop layers (factsheet chart tab)
  blurBackdrop: 30,
  blurBackdropContent: 31,

  // Persistent banners
  cookieBanner: 40,

  // Inline menus — submenus one tier below their parent
  submenu: 50,

  // Inline menus — popovers, dropdowns, inline dialogs
  menu: 60,

  // Application panels — side drawer, AI chat, date pickers
  panel: 70,

  // Priority overlays — symbol selector, dashboard target menus
  priorityLow: 80,
  priorityMid: 81,
  priority: 90,
  priorityTop: 91,

  // Application dialogs with critical content
  dialog: 100,

  // Blocking/loading states and preview tooltips
  loadingBackdrop: 110,

  // Notification toasts (always above interactive content)
  snackbar: 120,

  // Highcharts tooltip container (always on top)
  highchartsTooltip: 130
} as const;
